async function saveWishlistAsPDF() {
    fwLog('PDF-Export-Funktion aufgerufen.');
  
    if (typeof window.PDFLib === 'undefined') {
        fwLog('Fehler: PDFLib ist nicht definiert. Bitte überprüfe, ob die Bibliothek korrekt geladen wurde.');
        alert('Fehler: PDFLib ist nicht definiert. Bitte überprüfe, ob die Bibliothek korrekt geladen wurde.');
        return;
    }
  
    const pdfTemplateUrl = "https://cdn.shopify.com/s/files/1/0787/0513/1846/files/PDF-Vorlage.pdf";
    fwLog('PDF-Vorlagen-URL:', pdfTemplateUrl);
  
    const wishlistContainer = document.querySelector('.wishlist-items');
    if (!wishlistContainer) {
        alert('Wunschliste ist leer oder nicht gefunden.');
        fwLog('Fehler: Wunschliste ist leer oder nicht gefunden.');
        return;
    }
  
    const loadingOverlay = document.getElementById('loadingOverlay');
    loadingOverlay.style.display = 'flex';
    fwLog('Ladeanimation gestartet.');
  
    // Wunschliste als Bild erfassen
    const printableWishlist = wishlistContainer.cloneNode(true);
    printableWishlist.style.position = 'absolute';
    printableWishlist.style.left = '-9999px';
    document.body.appendChild(printableWishlist);
  
    printableWishlist.querySelectorAll('button, .fwRemoveWishlistItem').forEach(element => {
        element.remove();
    });
  
    html2canvas(printableWishlist, { useCORS: true, scale: 2 }).then(async (canvas) => {
        document.body.removeChild(printableWishlist);
  
        // Komprimiertes JPEG mit 80% Qualität
        const wishlistImage = canvas.toDataURL('image/jpeg', 0.8);
        fwLog('Wunschliste als hochqualitatives JPEG erfasst.');
  
        try {
            // PDF laden
            const pdfBytes = await fetch(pdfTemplateUrl).then(res => res.arrayBuffer());
            const pdfDoc = await PDFLib.PDFDocument.load(pdfBytes);
            const { width: pdfWidth, height: pdfHeight } = pdfDoc.getPages()[0].getSize();
  
            // Seitenränder in PDF-Punkten
            const marginLeftRight = 28.35; // 1 cm
            const marginTop = 141.75; // 5 cm oben
            const marginBottom = 113.4; // 4 cm unten
            const availableHeight = pdfHeight - marginTop - marginBottom;
            const availableWidth = pdfWidth - (2 * marginLeftRight);
  
            fwLog('pdfWidth:' + pdfWidth, 'pdfHeight:' + pdfHeight, 'marginLeftRight:' + marginLeftRight, 'marginTop:' + marginTop, 'marginBottom:' + marginBottom, 'availableWidth:' + availableWidth, 'availableHeight:' + availableHeight);
  
            // Bilddetails
            const imgOriginalWidth = canvas.width;
            const imgOriginalHeight = canvas.height;
            const aspectRatio = imgOriginalWidth / imgOriginalHeight;
  
            fwLog('imgOriginalWidth:' + imgOriginalWidth, 'imgOriginalHeight:' + imgOriginalHeight, 'aspectRatio:' + aspectRatio);
  
            // Seitenübergreifendes Rendering
            let currentY = 0;
            let page = pdfDoc.getPages()[0]; // Erste Seite verwenden
            while (currentY < imgOriginalHeight) {
                const sliceHeight = (availableHeight * imgOriginalHeight) / availableHeight;
  
                // Canvas für den Abschnitt erstellen
                const canvasSlice = document.createElement('canvas');
                canvasSlice.width = imgOriginalWidth;
                canvasSlice.height = sliceHeight;
  
                const ctx = canvasSlice.getContext('2d');
                ctx.drawImage(
                    canvas,
                    0,
                    currentY,
                    imgOriginalWidth,
                    sliceHeight,
                    0,
                    0,
                    canvasSlice.width,
                    canvasSlice.height
                );
  
                const slicedImage = canvasSlice.toDataURL('image/jpeg', 0.8);
  
  
                let imgWidth = availableWidth; // Fülle den gesamten verfügbaren horizontalen Platz
                let imgHeight = imgWidth / aspectRatio; // Passe die Höhe entsprechend dem Seitenverhältnis an
                
                // Falls die Höhe jetzt größer als der verfügbare Platz ist, korrigiere erneut
                if (imgHeight > availableHeight) {
                    imgHeight = availableHeight; // Höhe begrenzen
                    imgWidth = imgHeight * aspectRatio; // Breite entsprechend anpassen
                }
  
                // Abschnitt auf der Seite platzieren
                page.drawImage(await pdfDoc.embedJpg(slicedImage), {
                  x: marginLeftRight, // Startet am linken Rand
                  y: pdfHeight - marginTop - imgHeight, // Passt die vertikale Position an
                  width: imgWidth, // Skaliert die Breite auf den maximalen Platz
                  height: imgHeight, // Beibehaltung des Seitenverhältnisses
              });
  
                currentY += sliceHeight;
  
                // Neue Seite erstellen, falls noch Inhalt übrig ist
                if (currentY < imgOriginalHeight) {
                    page = pdfDoc.addPage([pdfWidth, pdfHeight]);
                }
            }
  
            // PDF speichern
            const modifiedPdfBytes = await pdfDoc.save();
            const blob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });
  
            // PDF herunterladen
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'Grossmengenanfrage.pdf';
            link.click();
            URL.revokeObjectURL(link.href);
  
            fwLog('PDF erfolgreich gespeichert als "Grossmengenanfrage.pdf".');
        } catch (error) {
            fwLog('Fehler beim Bearbeiten der PDF-Vorlage:', error);
            alert('Fehler beim Bearbeiten der PDF-Vorlage.');
        }
  
        loadingOverlay.style.display = 'none';
        fwLog('Ladeanimation gestoppt.');
    }).catch(error => {
        fwLog('Fehler während der HTML-Verarbeitung:', error);
        alert('Fehler während der HTML-Verarbeitung.');
        loadingOverlay.style.display = 'none';
    });
  }
  